export class PlayerStatistic {
    id: number = 0;
    yellowCards: number = 0;
    redCards: number = 0;
    substitutionsOut: number = 0;
    substitutionsIn: number = 0;
    lineups: number = 0;
    playerId: number = 0;
    goals: number = 0;
    minutesPlayed: number = 0;
    appearances: number = 0;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/player-statistic.model.ts